import Text from "@components/common/Text";
import React from "react";
import { FiArrowRightCircle } from "react-icons/fi";

const TextApp = () => {
    return (
        <>
            <Text>
                Descarga iMossos y colócate entre los mejores en el examen con
                nuestra aplicación de simulacros de exámenes tipo test.
                <br />
                <br />
                La aplicación más completa para acceder a Mossos d&apos;Esquadra
                y ascender a cabo.
                <ul className="mb-2 ml-0 mt-5">
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Practica lo que estás estudiando
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Refuerza tus puntos débiles
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Averigua a qué te enfrentas con exámenes reales de años
                        anteriores
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Practica donde y cuando quieras con tu móvil y/o tableta
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Amplía conocimientos de forma interactiva y dinámica
                    </li>
                </ul>
                <br />
                <ul className="mb-2 ml-0 mt-2">
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Mossos d&apos;Esquadra
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Caporal/a Mossos d&apos;Esquadra
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Psicotècnicos
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Actualidad
                    </li>
                </ul>
                <br />
                Haz realidad tus sueños y consigue plaza en la Policia de la
                Generalitat-Mossos d&apos;Esquadra.
            </Text>
        </>
    );
};

export default TextApp;
